<template>
    <div>
        <h2>Lade deine Unfallfotos hoch</h2>
        <div class="ion-text-right ion-padding-top">
            <template v-if="mode === 'kfz'">
                Unfallort Gesamtansicht
                <files-upload
                    v-model="unfallfotosSonstige"
                    :multiple="true"
                    id="unfallfotosSonstige"
                    flexDirection="row-reverse"
                ></files-upload>
                <div v-if="entstandenerschaden !== 'Fremdes KFZ'">
                    Schaden eigenes Fahrzeug
                    <files-upload
                        v-model="unfallfotosEigene"
                        :multiple="true"
                        id="unfallfotosEigene"
                        flexDirection="row-reverse"
                    ></files-upload>
                </div>
                <div v-if="entstandenerschaden !== 'Eigenes KFZ'">
                    Schaden fremdes Fahrzeug oder weitere Sachschäden
                    <files-upload
                        v-model="unfallfotosFremd"
                        :multiple="true"
                        id="unfallfotosFremd"
                        flexDirection="row-reverse"
                    ></files-upload>
                </div>
            </template>
            <template v-else>
                <files-upload
                    v-model="schadensfotos"
                    :multiple="true"
                    id="schadensfotos"
                    flexDirection="row-reverse"
                ></files-upload>
            </template>
            <ion-button
                class="-round -add-padding ion-margin-top"
                :disabled="false"
                @click="emitChange()"
                >Weiter</ion-button
            >
        </div>
    </div>
</template>

<script>
import FilesUpload from "@/components/FilesUpload";

export default {
    components: {
        FilesUpload,
    },
    props: {
        entstandenerschaden: String,
        mode: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            unfallfotosSonstige: [],
            unfallfotosEigene: [],
            unfallfotosFremd: [],
            schadensfotos: [],
        };
    },
    methods: {
        emitChange() {
            if (this.mode === "kfz") {
                this.$emit("change", [
                    {
                        id: "unfallfotosSonstige",
                        value: this.unfallfotosSonstige,
                    },
                    {
                        id: "unfallfotosEigene",
                        value: this.unfallfotosEigene,
                    },
                    {
                        id: "unfallfotosFremd",
                        value: this.unfallfotosFremd,
                    },
                ]);
            } else {
                this.$emit("change", [
                    { id: "schadensfotos", value: this.schadensfotos },
                ]);
            }
        },
    },
};
</script>

<style></style>
